<div class="row">
   <div class="col-lg-4">
      <div class="card shadow-sm">
         <div class="card-header">
            <h5 class="mb-0">{{editing?'Edit':'Add'}} Follow-Ups</h5>
         </div>

         <div class="card-body">
<!-- <div class="alert alert-danger" *ngIf="errMsg"><i class="bi bi-exclamation-triangle me-2"></i>{{ errMsg }}</div>
<div class="alert alert-success" *ngIf="okMsg"><i class="bi bi-check-circle me-2"></i>{{ okMsg }}</div> -->

<form #fuForm="ngForm" novalidate>
  <div class="mb-3">
    <label class="form-label req">Inquiry</label>
    <select class="form-select" name="enquiryNo" [(ngModel)]="frmData.inq_id" required #fuEnq="ngModel"
      [class.is-invalid]="fuEnq.invalid && fuEnq.touched">
      <option value="" selected>-- Select Inquiry --</option>
      <option *ngFor="let e of enquiries" [value]="e.id" [selected]="e.id==frmData.inq_id">
        {{ e.code }} — {{ e.iname }} {{e.gender=='M' ? 'S/o' : 'D/o'}} {{e.father}}
      </option>
    </select>
    <div class="invalid-feedback">Select an Inquiry</div>
  </div>

  <div class="mb-3">
    <label class="form-label req">Discussion Notes</label>
    <textarea class="form-control" name="fuNotes" rows="4" [(ngModel)]="frmData.fup_notes" required
      placeholder="Summary of conversation…" #fuNotes="ngModel"
      [class.is-invalid]="fuNotes.invalid && fuNotes.touched"></textarea>
    <div class="invalid-feedback">Required</div>
  </div>

  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label req">Mode</label>
      <select class="form-select" name="fuMode" [(ngModel)]="frmData.fup_mode" required #fuMode="ngModel"
        [class.is-invalid]="fuMode.invalid && fuMode.touched">
        <option value="">-- Select Mode --</option>
        <option *ngFor="let m of followUpModes" [value]="m.code">{{ m.name }}</option>
      </select>
      <div class="invalid-feedback">Required</div>
    </div>
    <div class="col-6">
      <label class="form-label req">Lead Status</label>
      <select class="form-select" name="fuStatus" [(ngModel)]="frmData.lead_status" required #fuStatus="ngModel"
        [class.is-invalid]="fuStatus.invalid && fuStatus.touched">
        <option value="">-- Select Status --</option>
        <option *ngFor="let s of leadStatuses" [value]="s.code">{{ s.name }}</option>
      </select>
      <div class="invalid-feedback">Required</div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-6">
      <label class="form-label">Follow-Up By</label>
      <select class="form-select" name="doneBy" [(ngModel)]="frmData.fup_uid">
        <option value="">-- Select --</option>
        <option *ngFor="let c of rec_con_users" [value]="c.id">
          {{ c.display_name }} ({{dataService.getRoleName(c.user_role[0].code)}})
        </option>
      </select>
    </div>
    <div class="col-auto mb-3">
      <label class="form-label req">Next Follow-Up Date</label>
      <input type="date" class="form-control" name="next_date" [(ngModel)]="frmData.next_date">
    </div>
  </div>
  <div class="w-100 d-flex justify-content-center gap-2 my-2">
    <button type="reset" class="btn btn-secondary">
      <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
    </button>
    <button type="button" class="btn btn-primary" (click)="isEdit ? doUpdate() : doSave()">
      <i class="bi bi-save me-1"></i>{{ isEdit ? 'Update' : 'Save Follow-Up' }}
    </button>
    <!-- <button type="button" class="btn btn-warning">
      <i class="bi bi-person-square"></i> Assign to
    </button> -->
  </div>
</form>

         </div>
      </div>
   </div>

   <div class="col-lg-8">
      <div class="card shadow-sm">
         <div class="card-header">
            <div class="row d-flex justify-content-between">
               <div class="col-md-6 d-flex align-items-center">
                  <h5 class="py-0 my-0">Follow-Ups List</h5>
               </div>

               <div class="col-md-4">
                  <input
                     class="form-control form-control-sm"
                     placeholder="Search..."
                     [(ngModel)]="searchText"
                  />
               </div>
              <div class="btn-group col-md-2">
               <button class="btn btn-sm btn-info" (click)="goBack()">Return</button>
              </div>
              <!-- <div class="btn-group col-md-3">
                <button type="button" class="btn btn-sm btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  {{tblData().title || 'Data Category'}}
                </button>
                <ul class="dropdown-menu dropdown-menu-end">
                  @for(md of mdata4load; track md) {
                  <li><button class="dropdown-item" type="button" 
                    (click)="setMaster(md)">{{md.title}}</button>
                  </li>
                  }
                </ul>
              </div> -->
            </div>
         </div>

         <div class="table-responsive">
            <table class="table table-hover">
               <thead>
                  <tr>
                     <th>#</th>
                     <th (click)="sort('fup_notes')">Notes</th>
                     <th width="250" (click)="sort('lead_status')">Status</th>
                     <th width="100" (click)="sort('next_date')">Dates</th>
                     <th width="120">Action</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngFor="let item of follow_ups; let idx=index;">
                     <td>{{idx+1}}.</td>
                     <td><div class="ellipsis2">{{item.fup_notes}}</div></td>
                     <td>{{dataService.getLeatStatus(item.lead_status)}}<br>
                      <small>follow by <u>{{dataService.getInqMode(item.fup_mode)}}</u></small>
                     </td>
                     <td><small>{{dataService.ymd2dmy(item?.fup_date?.substr(0,10))}}</small>
                      {{dataService.ymd2dmy(item?.next_date?.substr(0,10))}}</td>
                     <td>
                        <button
                           class="btn btn-sm me-1"
                           (click)="edit(item)"
                        >
                          <i class="bi bi-pencil-square text-success"></i>
                        </button>

                        <button
                           class="btn btn-sm"
                           (click)="deleteClick(item.id)"
                        >
                          <i class="bi bi-trash3-fill text-danger"></i>
                        </button>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>

         <!-- <div class="card-footer" *ngIf="totalPages()>1">
            <button
               class="btn btn-outline-primary btn-sm me-2"
               (click)="changePage(currentPage-1)"
            >
               Previous
            </button>

            Page {{currentPage}} / {{totalPages()}}

            <button
               class="btn btn-outline-primary btn-sm ms-2"
               (click)="changePage(currentPage+1)"
            >
               Next
            </button>
         </div> -->
      </div>
   </div>
</div>
